import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FormLabel, Stack, Typography, useTheme } from '@mui/material';

import IconWithTooltip from '../IconWithTooltip/IconWithTooltip';

import type { DataGridFieldProps } from './types';

export const DataGridField = (props: DataGridFieldProps) => {
  const {
    orientation = 'vertical',
    tooltip,
    label,
    fullWidth,
    required,
    validationState = 'none',
    validationMessage,
    showValidationMessageIcon,
    children,
  } = props;
  const theme = useTheme();
  return (
    <Stack direction="column" spacing={1} sx={{ width: fullWidth ? '100%' : undefined }}>
      <Stack
        direction={orientation === 'vertical' ? 'column' : 'row'}
        spacing={1}
        sx={{ alignItems: orientation === 'vertical' ? undefined : 'center' }}
      >
        <FormLabel>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant="body2" color={theme.palette.text.primary}>
              {label}
            </Typography>
            {tooltip && <IconWithTooltip tooltipTitle={tooltip} icon={<InfoOutlinedIcon />} />}
            {required && (
              <Typography variant="caption" color={theme.palette.error.light}>
                *
              </Typography>
            )}
          </Stack>
        </FormLabel>
        {children}
      </Stack>
      {validationState === 'error' && validationMessage && (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          {showValidationMessageIcon && <ErrorOutlineIcon color="error" fontSize="small" />}
          <Typography variant="caption" color={theme.palette.error.main}>
            {validationMessage}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
